import { createFileRoute, notFound } from "@tanstack/react-router";

import { AccountView } from "@/components/pages/AccountView";
import { meta } from "@/content/meta";
import { isLocale } from "@/i18n/locales";
import { seoHead } from "@/lib/site";

export const Route = createFileRoute("/$locale/account")({
  head: ({ params }) =>
    isLocale(params.locale)
      ? seoHead({
          locale: params.locale,
          path: "/account",
          noIndex: true,
          ...meta[params.locale].account,
        })
      : {},
  component: AccountRoute,
});

function AccountRoute() {
  const { locale } = Route.useParams();
  if (!isLocale(locale)) throw notFound();
  return <AccountView locale={locale} />;
}

